// The debug page's tabs, kept apart from the page so the router can read the URL without loading the console chunk.
export const DEBUG_TABS = [
  "overview",
  "terminal",
  "logs",
  "requests",
  "firmware",
  "link",
  "usage",
  "data",
  "audit",
] as const;
export type DebugTab = (typeof DEBUG_TABS)[number];

export function parseDebugTab(search: Record<string, unknown>): { tab?: DebugTab } {
  return DEBUG_TABS.includes(search.tab as DebugTab) ? { tab: search.tab as DebugTab } : {};
}
